export default "__VITE_ASSET__3d16825c__"